// Common QA attribute names (HTML `data-*` keys)
export const QA_ATTRIBUTES = {
  TAG: 'data-qa-tag',
  STATES: 'data-qa-states',
};

// Search input
export const QA_SEARCH_INPUT = {
  CLEAR_BUTTON: 'search-clear-button',
  INPUT: 'search-input',
};

// Navigation sidebar
export const QA_NAVIGATION_SIDEBAR = {
  BACK_BUTTON: 'navigation-sidebar-back-button',
  TITLE: 'navigation-sidebar-title',
  HELP_CENTER: 'navigation-sidebar-help-center',
  MY_TICKETS: 'navigation-sidebar-my-tickets',
  LOGOUT_BUTTON: 'navigation-sidebar-logout-button',
  MORE_BUTTON: 'navigation-sidebar-more-button',
  PRICING_LINK: 'navigation-sidebar-pricing-link',
  TERM_OF_SERVICE_LINK: 'navigation-sidebar-term-of-service-link',
  PRIVACY_LINK: 'navigation-sidebar-privacy-link',
};

// Right sidebar (contact/support form)
export const QA_RIGHT_SIDEBAR = {
  CHAT_BUTTON: 'right-sidebar-chat-button',
  CONTACT_US_PHONE: 'right-sidebar-contact-us-phone-link',
  EMAIL_INPUT: 'right-sidebar-email-input',
  EMAIL_INPUT_ERROR: 'right-sidebar-email-input-error',
  CATEGORY_SELECT: 'right-sidebar-category-select',
  MESSAGE_TEXTAREA: 'right-sidebar-message-textarea',
  SUBMIT_TICKET_BUTTON: 'right-sidebar-submit-ticket-button',
};

// Help Center (home page)
export const QA_HELP_CENTER = {
  CATEGORIES_LIST: 'help-center-categories-list',
  LOADING_CARDS: 'help-center-loading-cards',
  CARD_ITEM: 'help-center-card-item',
  CARD_ITEM_TITLE: 'help-center-card-item-title',
  CARD_ITEM_DESCRIPTION: 'help-center-card-item-description',
  RECENT_TOPICS_LIST: 'help-center-recent-topics-list',
  RECENT_TOPIC_ITEM: 'help-center-recent-topic-item',
  RECENT_TOPIC_ITEM_LINK: 'help-center-recent-topic-item-link',
};

// Help Center category page
export const QA_HELP_CENTER_CATEGORY = {
  TITLE: 'help-center-category-title',
  DESCRIPTION: 'help-center-category-description',
  TOPICS_LIST: 'help-center-category-topics-list',
  RELATED_CATEGORIES_LIST: 'help-center-category-related-categories-list',
};

// Help Center topic/article page
export const QA_HELP_CENTER_TOPIC = {
  ITEM: 'help-center-topic-item',
  TITLE: 'help-center-topic-title',
  DESCRIPTION: 'help-center-topic-description',
  HELPFUL: 'help-center-topic-helpful',
  HELPFUL_NOT_HELPFUL: 'help-center-topic-helpful-not-helpful',
  HELPFUL_HELPFUL: 'help-center-topic-helpful-helpful',
  RELATED_TOPICS_LIST: 'help-center-topic-related-topics-list',
  RELATED_TOPICS_ITEM: 'help-center-topic-related-topics-item',
};

// Breadcrumbs
export const QA_BREADCRUMBS = {
  LIST: 'breadcrumbs-list',
  ITEM: 'breadcrumbs-item',
  ITEM_ROOT: 'breadcrumbs-item-root',
};

// History page (tickets/chats list)
export const QA_HISTORY_PAGE = {
  LIST: 'history-page-list',
  ITEM: 'history-page-item',
  EMPTY_PAGE: 'history-page-empty-page',
  EMPTY_PAGE_DESCRIPTION: 'history-page-empty-page-description',
  EMPTY_PAGE_BUTTON: 'history-page-empty-page-button',
  CHAT_ITEM: 'history-page-chat-item',
};

// Ticket details page
export const QA_TICKET_PAGE = {
  TICKET_STATUS: 'ticket-status',
  TICKET_HEADER_AUTHOR: 'ticket-header-author',
  TICKET_HEADER_AUTHOR_NAME: 'ticket-header-author-name',
  TICKET_HEADER_DESCRIPTION: 'ticket-header-description',
  TICKET_RESOLVE_BUTTON: 'ticket-resolve-button',
  TICKET_MESSAGES_COUNT: 'ticket-header-messages-count',
  TICKET_REPLY_TEXTAREA: 'ticket-reply-textarea',
  TICKET_REPLY_FILE_INPUT: 'ticket-reply-file-input',
  TICKET_REPLY_ATTACH_FILE_BUTTON: 'ticket-reply-attach-file-button',
  TICKET_REPLY_REPLY_BUTTON: 'ticket-reply-reply-button',
  TICKET_REPLY_ATTACHMENTS_CONTAINER: 'ticket-reply-attachments-container',
  TICKET_OPEN_AGAIN_BUTTON: 'ticket-open-again-button',
  TICKET_MESSAGES_CONTAINER: 'ticket-messages-container',
  TICKET_MESSAGE_ITEM: 'ticket-message-item',
  TICKET_MESSAGE_AUTHOR_NAME: 'ticket-message-author-name',
  TICKET_MESSAGE_CREATED_AT: 'ticket-message-created-at',
  TICKET_MESSAGE_TEXT: 'ticket-message-text',
  TICKET_MESSAGE_ATTACHMENTS_CONTAINER: 'ticket-message-attachments-container',
};

// Generic list components
export const QA_LIST = {
  ITEM: 'list-item',
  ITEM_STATUS: 'list-item-status',
  ITEM_DESCRIPTION: 'list-item-description',
  ITEM_TITLE: 'list-item-title',
  ITEM_RATE: 'list-item-rate',
};

// Tabs
export const QA_TABS = {
  LIST: 'tabs-list',
  ITEM: 'tab-item',
  SORT_ACTION: 'sort-action',
};

// Chat history page
export const QA_CHAT_HISTORY_PAGE = {
  CHAT_STATUS: 'chat-history-chat-status',
  CHAT_STATUS_TITLE: 'chat-history-chat-status-title',
  CHAT_STATUS_RATING: 'chat-history-chat-status-rating',
  CHAT_MESSAGES_CONTAINER: 'chat-history-messages-container',
  CHAT_HISTORY_DOESNT_EXIST: 'chat-history-doesnt-exist',
  CHAT_MESSAGE: 'chat-history-message',
  CHAT_MESSAGE_CONTENT: 'chat-history-message-content',
  CHAT_MESSAGE_CREATED_AT: 'chat-history-message-created-at',
};
